/* eslint-disable */
/* prettier-ignore */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-self-compare */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/display-name */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable no-console */
/* eslint-disable camelcase */
/* eslint-disable prefer-const */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Fade,
    Chip,
    IconButton,
    Menu,
    MenuItem,
    CircularProgress,
    Tooltip,
    Tabs,
    Tab
} from '@mui/material';
import {
    NavigateNext,
    NavigateBefore,
    MoreVert as MoreVertIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    Block as BlockIcon,
    List as ListIcon,
    Add as AddIcon
} from '@mui/icons-material';
import { useBranchCode } from 'hooks/api/terminology/branch-code/useBranchCode';
import Swal from 'sweetalert2';
import { PaginationButton, StyledTableContainer, globalColor } from '../../ConstantColors';
import { BranchCodeForm } from './add';
import {
    AuditCell,
    ClampedText,
    CodeText,
    ConfigurationActionMenu,
    ConfigurationPagination,
    ConfigurationStatusChip,
    stickyActionCellSx,
    stickyActionHeadSx,
    tableSx
} from '../components/ConfigurationTable';

// Toast Configuration
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
});

const ActionMenu = ({ branchCode, onEdit, onDelete, onToggleActive }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        handleClose();
        action();
    };

    return (
        <>
            <Tooltip title="Actions">
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                <MenuItem onClick={() => handleAction(onEdit)}>
                    <EditIcon sx={{ mr: 1 }} /> Edit
                </MenuItem>
                <MenuItem onClick={() => handleAction(onToggleActive)} sx={{ color: branchCode.isActive ? 'error.main' : 'success.main' }}>
                    <BlockIcon sx={{ mr: 1 }} /> {branchCode.isActive ? 'Deactivate' : 'Activate'}
                </MenuItem>
                <MenuItem onClick={() => handleAction(onDelete)} sx={{ color: 'error.main' }}>
                    <DeleteIcon sx={{ mr: 1 }} /> Delete
                </MenuItem>
            </Menu>
        </>
    );
};

// Main Branch Code Component
const BranchCode = () => {
    const { listBranchCodes, branchCodes, createBranchCode, deleteBranchCode, updateBranchCode, getBranchCodeById } = useBranchCode();
    const [page, setPage] = useState(0);
    const [selectedBranchCode, setSelectedBranchCode] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(0);
    const rowsPerPage = 5;

    const fetchBranchCodes = async () => {
        setLoading(true);
        try {
            await listBranchCodes(0, 100);
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch branch codes'
            });
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBranchCodes();
    }, []);

    const handleEdit = async (branchCode) => {
        try {
            const freshData = await getBranchCodeById(branchCode.id);
            if (freshData) {
                setSelectedBranchCode(freshData);
                setActiveTab(1); // Switch to Add/Edit tab
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: 'Failed to fetch branch code details'
            });
        }
    };

    const handleSubmit = async (values, { resetForm }) => {
        try {
            const formattedValues = {
                ...values,
                organization: values.organization
            };

            if (values.id) {
                await updateBranchCode(values.id, formattedValues);
            } else {
                await createBranchCode(formattedValues);
            }

            resetForm();
            setSelectedBranchCode(null);
            setActiveTab(0); // Switch back to List tab
            await fetchBranchCodes();

            Toast.fire({
                icon: 'success',
                title: `BranchCode ${values.id ? 'updated' : 'added'} successfully`
            });
        } catch (error) {
            Toast.fire({
                icon: 'error',
                title: `Failed to ${values.id ? 'update' : 'add'} branchCode`
            });
        }
    };

    const handleDelete = async (branchCodeId) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                await deleteBranchCode(branchCodeId);
                await fetchBranchCodes();
                Toast.fire({
                    icon: 'success',
                    title: 'Branch Code deleted successfully'
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: 'Failed to delete branch code'
                });
            }
        }
    };

    const handleToggleActive = async (branchCode) => {
        const action = branchCode.isActive ? 'deactivate' : 'activate';
        const result = await Swal.fire({
            title: `Are you sure?`,
            text: `Do you want to ${action} this branch code?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: branchCode.isActive ? '#d33' : '#28a745',
            cancelButtonColor: '#3085d6',
            confirmButtonText: `Yes, ${action} it!`
        });

        if (result.isConfirmed) {
            try {
                await updateBranchCode(branchCode.id, {
                    ...branchCode,
                    isActive: !branchCode.isActive
                });
                await fetchBranchCodes();
                Toast.fire({
                    icon: 'success',
                    title: `Branch Code ${action}d successfully`
                });
            } catch (error) {
                Toast.fire({
                    icon: 'error',
                    title: `Failed to ${action} branchCode`
                });
            }
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        if (newValue === 0) {
            setSelectedBranchCode(null);
        }
    };

    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                <Tabs value={activeTab} onChange={handleTabChange} aria-label="branch code tabs">
                    <Tab
                        icon={<ListIcon />}
                        iconPosition="start"
                        label="Branch Code List"
                        sx={{ textTransform: 'none' }}
                    />
                    <Tab
                        icon={<AddIcon />}
                        iconPosition="start"
                        label={selectedBranchCode ? "Edit Branch Code" : "Add Branch Code"}
                        sx={{ textTransform: 'none' }}
                    />
                </Tabs>
            </Box>

            {activeTab === 1 && (
                <BranchCodeForm
                    initialData={selectedBranchCode}
                    onSubmit={handleSubmit}
                    onClear={() => {
                        setSelectedBranchCode(null);
                        setActiveTab(0);
                    }}
                />
            )}

            {activeTab === 0 && (
                <Box sx={{ mt: 4 }}>
                    {loading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
                            <CircularProgress color="primary" />
                        </Box>
                    ) : (
                        <>
                            <Fade in timeout={1500}>
                                <StyledTableContainer component={Paper}>
                                    <Table size="small" sx={tableSx(980)}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ width: 126 }}>Organisation</TableCell>
                                                <TableCell>Name</TableCell>
                                                <TableCell sx={{ width: 108 }}>Code</TableCell>
                                                <TableCell sx={{ width: 210 }}>Description</TableCell>
                                                <TableCell sx={{ width: 126 }}>Created</TableCell>
                                                <TableCell sx={{ width: 126 }}>Updated</TableCell>
                                                <TableCell sx={{ width: 92 }}>Status</TableCell>
                                                <TableCell align="center" sx={stickyActionHeadSx}>Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {branchCodes.length > 0 ? (
                                                branchCodes.slice(page * rowsPerPage, (page + 1) * rowsPerPage).map((branchCode) => (
                                                    <TableRow key={branchCode.id}>
                                                        <TableCell><ClampedText maxWidth={126}>{branchCode.organization}</ClampedText></TableCell>
                                                        <TableCell><ClampedText>{branchCode.name}</ClampedText></TableCell>
                                                        <TableCell><CodeText>{branchCode.code}</CodeText></TableCell>
                                                        <TableCell><ClampedText>{branchCode.description}</ClampedText></TableCell>
                                                        <TableCell>
                                                            <AuditCell by={branchCode.createdBy} at={branchCode.createdAt} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <AuditCell by={branchCode.lastModifiedBy} at={branchCode.lastModifiedAt} />
                                                        </TableCell>
                                                        <TableCell>
                                                            <ConfigurationStatusChip active={branchCode.isActive} />
                                                        </TableCell>
                                                        <TableCell align="center" sx={stickyActionCellSx}>
                                                            <ConfigurationActionMenu
                                                                label={branchCode.name}
                                                                actions={[
                                                                    { label: 'Edit', icon: EditIcon, onClick: () => handleEdit(branchCode) },
                                                                    {
                                                                        label: branchCode.isActive ? 'Deactivate' : 'Activate',
                                                                        icon: BlockIcon,
                                                                        color: branchCode.isActive ? '#b54708' : '#25643b',
                                                                        onClick: () => handleToggleActive(branchCode)
                                                                    },
                                                                    {
                                                                        label: 'Delete',
                                                                        icon: DeleteIcon,
                                                                        color: '#d92d20',
                                                                        onClick: () => handleDelete(branchCode.id)
                                                                    }
                                                                ]}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={8} align="center" sx={{ height: 132 }}>
                                                        No branch codes available
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                    <ConfigurationPagination
                                        page={page}
                                        rowsPerPage={rowsPerPage}
                                        total={branchCodes.length}
                                        onPageChange={setPage}
                                    />
                                </StyledTableContainer>
                            </Fade>
                        </>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default BranchCode;
